// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Admin_wrapper__ABW8a","mainSection":"Admin_mainSection__3qpoW"};